// packages/ui/src/theme/sharedComponents.ts
//
// Component rules every MUI theme of TourTask includes, whatever its look: the backoffice, the public site and
// the admin app's previews (through `baseTheme`), the admin app, the storefront and its nested header and
// default themes, and the embed's chat and reviews widgets. A rule about how a control behaves is written here
// once and spread into each theme's `components` — never repeated as an `sx` at the places that use the control.
import type { ThemeOptions } from '@mui/material/styles';

export const sharedComponents = {
  // A radio's, checkbox's or switch's click area is the control and its label, never the empty row beside
  // them: in a flex column (RadioGroup, FormGroup, Stack) a FormControlLabel stretches across the row, and a
  // click anywhere in it would pick the option — a misclick. `fit-content` stops the stretch in every
  // container. A card-style option, bordered so its whole card reads as one target, sets its own `width`
  // (`BookingTimeSelector`).
  MuiFormControlLabel: {
    styleOverrides: {
      root: { width: 'fit-content' },
    },
  },
} satisfies NonNullable<ThemeOptions['components']>;
